/* This file is autogenerated, see readme.md for instructions */
import InfoSmallSvgIcon from '@bloomreach/banana-theme/icons/info-small.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const InfoSmallIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <InfoSmallSvgIcon />
    </Icon>
  );
});

InfoSmallIcon.displayName = 'InfoSmallIcon';

export default InfoSmallIcon;
